const graph = {
  "queryState": {
    "layerCatalogLoadFailed": "មិនអាចផ្ទុកបញ្ជីស្រទាប់បានទេ",
    "savedSectionListLoadFailed": "មិនអាចផ្ទុកទិន្នន័យដែលបានរក្សាទុកបានទេ",
    "exportListLoadFailed": "មិនអាចផ្ទុកបញ្ជីឯកសារនាំចេញបានទេ",
    "shootingDateListLoadFailed": "មិនអាចផ្ទុកបញ្ជីកាលបរិច្ឆេទថតបានទេ",
  },
  "checkCrossSection": "ពិនិត្យផ្នែក",
  "checkLongitudeSection": "ពិនិត្យផ្នែកបណ្ដោយ",
  "height": "កម្ពស់",
  "distance": "ចម្ងាយ",
  "line": "ខ្សែ",
  "alignment": "ការតម្រឹម",
  "stratum": "ស្រទាប់ដី",
  "designHeight": "ប្លង់",
  "check": "ពិនិត្យ",
  "longitudeSection": "ផ្នែកបណ្ដោយ",
  "specificSection": "ជាក់លាក់",
  "crossSection": "ផ្នែកឆ្លង",
  "crossSectionList": "បញ្ជីផ្នែកឆ្លង",
  "crossSectionGraph": "ក្រាហ្វផ្នែកឆ្លង",
  "perpendicularInterval": "ចន្លោះផ្នែកឆ្លង",
  "pointInterval": "ចន្លោះចំណុច",
  "pointSetting": "ការកំណត់ទីចំណុច",
  "detailSetting": "ការកំណត់លម្អិត",
  "startPoint": "ចំណុចចាប់ផ្ដើម",
  "endPoint": "ចំណុចបញ្ចប់",
  "section": "ផ្នែក",
  "sectionStartPoint": "ចំណុចចាប់ផ្ដើម",
  "sectionEndPoint": "ចំណុចបញ្ចប់",
  "original": "មើលដើម",
  "detail": "មើលលម្អិត",
  "startPointError": "ចំណុចចាប់ផ្ដើមមិនអាចតូចជាងតម្លៃដើម។",
  "enterBranch": "សូមបញ្ចូលទីចំណុច។",
  "validate": {
    "dxfSaveFileDownloadError": "មានកំហុសក្នុងការទាញយកឯកសារ។ សូមសាកល្បងម្ដងទៀត។",
    "dxfSaveFileGenerateNotice": "ការស្នើសុំបង្កើតឯកសារត្រូវបានធ្វើ។ ជាធម្មតាបញ្ចប់ក្នុង ១០ នាទី។ សូមមើលក្រោយ។",
    "dxfSaveFileGenerateError": "ការបង្កើតឯកសារបានបរាជ័យ។ សូមសាកល្បងម្ដងទៀតក្រោយ។",
    "noSavedData": "គ្មានទិន្នន័យដែលបានរក្សាទុក។",
    "failDeleteData": "ការលុបទិន្នន័យបានបរាជ័យ។ សូមសាកល្បងម្ដងទៀត។",
    "savePerpendicular": "ផ្នែកឆ្លងត្រូវបានរក្សាទុក។",
    "deletePerpendicular": "ផ្នែកឆ្លងត្រូវបានលុប។",
    "existingCrossSection": "មានផ្នែកឆ្លងដែលបានរក្សាទុករួចហើយ។ សូមលុបហើយសាកល្បងម្ដងទៀត។",
    "leftRightSpacing": "ចន្លោះខាងឆ្វេង-ស្ដាំត្រូវតែធំជាងចន្លោះចំណុច។",
    "pointIntervalMin": "ចន្លោះចំណុចត្រូវតែយ៉ាងហោចណាស់ {{min}} ម។",
    "endPointInfo": "ប្រសិនបើមិនបញ្ចូលចំណុចបញ្ចប់ ឬចំណុចបញ្ចប់វែងជាងខ្សែ អ្នកនឹងឃើញផ្នែកទាំងមូល។",
    "lngStartPoint": "ចំណុចចាប់ផ្ដើមផ្នែកបណ្ដោយត្រូវបានឆ្លុះក្នុងឯកសារ TEXT តែប៉ុណ្ណោះ។",
    "startStepError": "ចំណុចចាប់ផ្ដើមមិនអាចតូចជាងតម្លៃដើម។",
    "endStepError": "ចំណុចបញ្ចប់មិនអាចតូចជាងចំណុចចាប់ផ្ដើម។",
    "sameStepError": "ចំណុចចាប់ផ្ដើមនិងចំណុចបញ្ចប់មិនអាចដូចគ្នា។",
    "maxStratumFilesSelected": "អាចជ្រើសរើសឯកសារបានអតិបរិមា ៣ ។",
    "maxStep": "ចន្លោះត្រូវតែ ១០០ ឬតិចជាង។",
    "increment": "ចន្លោះត្រូវតែជាពហុគុណ ៥។",
    "equal": "ចន្លោះចំណុចត្រូវតែស្មើឬតូចជាងចន្លោះផ្នែកឆ្លង។",
    "setPoint": "សូមកំណត់ចំណុចចាប់ផ្ដើមនិងចំណុចបញ្ចប់",
    "pointAdditionError": "ទីចំណុចបន្ថែមមិនអាចតូចជាងចំណុចចាប់ផ្ដើម។",
    "pointAdded": "ផ្នែកឆ្លងជាក់លាក់ត្រូវបានបន្ថែម។",
    "pointAdditionFailed": "ការបន្ថែមផ្នែកឆ្លងជាក់លាក់បានបរាជ័យ។ សូមសាកល្បងម្ដងទៀតក្រោយ។",
    "pointAdditionTargetFailed": "មានផ្នែកឆ្លងនៅចម្ងាយនោះហើយ។ សូមពិនិត្យចម្ងាយ។",
    "distanceExceedsSegmentLength": "ចម្ងាយដែលបានបញ្ចូលលើសជាងប្រវែងខ្សែ។",
    "crossSectionDeletionFailed": "ការលុបផ្នែកឆ្លងបានបរាជ័យ។ សូមសាកល្បងម្ដងទៀតក្រោយ។"
  },
  "perpendicularList": "បញ្ជីផ្នែកឆ្លង",
  "selectPerpendicular": "សូមជ្រើសរើសផ្នែកឆ្លង",
  "perpendicularDeleted": "ផ្នែកឆ្លងត្រូវបានលុប។",
  "deleteSavedTitle": "លុបផ្នែកឆ្លងដែលបានរក្សាទុក",
  "deleteSavedSectionMessage": "លុបចន្លោះ {{name}} ឬ?",
  "deleteSavedStationMessage": "លុបចំណុចវាស់ {{name}} ឬ?",
  "exportSection": "នាំចេញ",
  "enterDistance": "សូមបញ្ចូលចម្ងាយ។",
  "enterDistanceInRange": "សូមបញ្ចូលក្នុងជួរ។",
  "perpendicularDataNotFound": "រកមិនឃើញទិន្នន័យផ្នែកឆ្លងនៅចម្ងាយនោះ។",
  "specialPerpendicularAdded": "ផ្នែកឆ្លងពិសេសត្រូវបានបន្ថែម។",
  "perpendicularAlreadyExists": "មានផ្នែកឆ្លងនៅទីតាំងដូចគ្នាហើយ។",
  "specialPerpendicularAddFailed": "ការបន្ថែមផ្នែកឆ្លងពិសេសបានបរាជ័យ។",
  "perpendicularGraph": "ក្រាហ្វផ្នែកឆ្លង",
  "addSpecialPerpendicular": "បន្ថែមផ្នែកឆ្លងពិសេស",
  "noSavedData": "គ្មានទិន្នន័យដែលបានរក្សាទុក។",
  "loading": "កំពុងផ្ទុក",
  "delete": "លុប",
  "cancel": "បោះបង់",
  "edit": "កែប្រែ",
  "confirm": "ពិនិត្យ",
  "perpendicularSelectionTree": "ដើមជ្រើសផ្នែកឆ្លង",
  "loadingInProgress": "កំពុងផ្ទុក...",
  "createFile": "សូមបង្កើតឯកសារ។",
  "exportPerpendicularData": "នាំចេញទិន្នន័យផ្នែកឆ្លង",
  "invalidFileFormat": "ទម្រង់ឯកសារមិនត្រឹមត្រូវ។",
  "fileReadFailed": "ការអានឯកសារបានបរាជ័យ។",
  "noSectionSelected": "គ្មានផ្នែកដែលបានជ្រើសរើស។",
  "selectFileToExport": "សូមជ្រើសរើសឯកសារដើម្បីនាំចេញ។",
  "noExportableFiles": "គ្មានឯកសារអាចនាំចេញ។",
  "csvDownloaded": "ឯកសារ CSV ត្រូវបានទាញយក។",
  "csvDownloadFailed": "ការទាញយក CSV បានបរាជ័យ។",
  "dxfDownloaded": "ឯកសារ DXF ត្រូវបានទាញយក។",
  "dxfDownloadFailed": "ការទាញយក DXF បានបរាជ័យ។",
  "earthworkTableFeatureComingSoon": "មុខងារទាញយកតារាងដីសំណង់កំពុងត្រូវបានរៀបចំ។",
  "selectFileToDelete": "សូមជ្រើសរើសឯកសារដើម្បីលុប។",
  "fileDeleted": "ឯកសារត្រូវបានលុប។",
  "fileNotFound": "រកមិនឃើញឯកសារ។",
  "fileDeletionFailed": "ការលុបឯកសារបានបរាជ័យ។",
  "selectFileToRename": "សូមជ្រើសរើសឯកសារដើម្បីប្ដូរឈ្មោះ។",
  "noFileNameChanged": "គ្មានឈ្មោះឯកសារដែលបានផ្លាស់ប្ដូរ។",
  "fileRenamed": "ឈ្មោះឯកសារត្រូវបានប្ដូរ។",
  "duplicateFileName": "មានឈ្មោះឯកសារដូចគ្នាហើយ។",
  "fileRenameFailed": "ការប្ដូរឈ្មោះឯកសារបានបរាជ័យ។",
  "fileNameSlashNotAllowed": "ឈ្មោះឯកសារមិនអាចមាន / ។",
  "fileInfoNotFound": "រកមិនឃើញព័ត៌មានឯកសារ។",
  "fileUpdateStarted": "ការអាប់ដេតឯកសារបានចាប់ផ្ដើម។",
  "perpendicularDataNotFoundForUpdate": "រកមិនឃើញទិន្នន័យផ្នែកឆ្លង។",
  "fileUpdateFailed": "ការអាប់ដេតឯកសារបានបរាជ័យ។",
  "fileName": "ឈ្មោះឯកសារ",
  "includedFiles": "ឯកសារដែលបានរួមបញ្ចូល",
  "updateDate": "ថ្ងៃអាប់ដេត",
  "update": "អាប់ដេត",
  "done": "បញ្ចប់",
  "creating": "កំពុងបង្កើត",
  "rename": "ប្ដូរឈ្មោះ",
  "download": "ទាញយក",
  "txtDownloadHelp": "អាចគូរផ្នែកឆ្លងក្នុងកម្មវិធី RP, BIMNODE ។",
  "earthworkTable": "តារាងដីសំណង់",
  "earthworkTableRequirement": "តារាងដីសំណង់ត្រូវការទាំងកម្ពស់ដីនិងកម្ពស់ការរចនា",
  "earthworkTableNoData": "គ្មានទិន្នន័យតារាង។",
  "earthworkTableDownloaded": "តារាងដីសំណង់ត្រូវបានទាញយក។",
  "earthworkTableDownloadFailed": "ការទាញយកតារាងដីសំណង់បានបរាជ័យ។",
  "earthworkStationQuantity": "បរិមាណផ្នែកដីសំណង់",
  "earthworkStationQuantityRequirement": "បរិមាណផ្នែកដីសំណង់ត្រូវការទាំងកម្ពស់ដីនិងកម្ពស់ការរចនា",
  "earthworkStationQuantityNoData": "គ្មានទិន្នន័យការបញ្ចូល/ការផ្ដាច់ដីក្នុងប្រចាំ Station ។",
  "earthworkStationQuantityDownloaded": "បរិមាណផ្នែកដីសំណង់ត្រូវបានទាញយក។",
  "earthworkStationQuantityDownloadFailed": "ការទាញយកបរិមាណផ្នែកដីសំណង់បានបរាជ័យ។",
  "select": "ជ្រើសរើស",
  "itemsSelected": "ត្រូវបានជ្រើសរើស",
  "multipleSelectable": "អាចជ្រើសរើសបានច្រើន",
  "singleSelectable": "អាចជ្រើសរើសបានតែមួយ",
  "selectStandardTimeSeries": "ជ្រើសរើសស៊េរីពេលវេលាយោង",
  "standard": "យោង",
  "elevationProfile": "ប្រវត្តិរូបកម្ពស់",
  "partialMode": "របៀបខ្លះ",
  "resetView": "ស្ដារទិដ្ឋភាព",
  "crossSectionElevationProfile": "ប្រវត្តិរូបកម្ពស់ផ្នែកឆ្លង",
  "crossSectionNumber": "ផ្នែកឆ្លងទី",
  "station": "ចំណុចស្ទង់",
  "quantityTable": "តារាងបរិមាណ",
  "quantityTableTooltip": "ត្រូវការទាំងកម្ពស់ការរចនានិងកម្ពស់ដីដើម\nដើម្បីពិនិត្យតារាងបរិមាណ។",
  "crossSectionQuantityTable": "តារាងបរិមាណផ្នែកឆ្លង",
  "baseDate": "យោង",
  "excelDownload": "ទាញយក Excel",
  "noQuantityData": "មិនអាចគណនាតារាងបរិមាណ ព្រោះគ្មានកម្ពស់ការរចនា ឬកម្ពស់ដីដើមនៅទីនោះ។",
  "planned": "ផែនការ",
  "progressed": "ដំណើរការ",
  "currentHeight": "កម្ពស់បច្ចុប្បន្ន",
  "fill": "ការបំពេញ",
  "cut": "ការកាត់",
  "fillSubgrade": "Subgrade",
  "fillRoadbed": "ផ្លូវ",
  "fillUncompacted": "មិនបានដំ",
  "fillRockFill": "ការបំពេញថ្ម",
  "cutSoilCut": "ដី",
  "cutRipping": "ការរ៉ិប",
  "cutBlasting": "ការផ្ទុះថ្ម",
  "earthworkSection": "ផ្នែក",
  "earthworkFillGroup": "ការបំពេញ",
  "earthworkCutGroup": "ការកាត់",
  "earthworkSubtotal": "សរុបរង",
  "earthworkColType": "ប្រភេទ",
  "earthworkColMaterial": "ប្រភេទសម្ភារ",
  "earthworkColPlannedQty": "បរិមាណផែនការ",
  "earthworkColRemainingQty": "បរិមាណដីដែលសល់",
  "earthworkColDailyTotal": "សរុបប្រចាំថ្ងៃ",
  "earthworkKeyDesignHeight": "កម្ពស់ការរចនា",
  "earthworkKeyGroundHeight": "កម្ពស់ដី",
  "timeSeries": "ស្ថានភាព",
  "maxFourSelectable": "*អាចជ្រើសរើសបានអតិបរិមា ៤",
  "complete": "បញ្ចប់",
  "layer": "ស្រទាប់",
  "planDropdown": "ផែនការ",
  "stratumDropdown": "ស្រទាប់ដី",
  "legendGround": "កម្ពស់ដីដើម",
  "legendDesign": "កម្ពស់ការរចនា",
  "stratumMaxThree": "ស្រទាប់ដី (អាចជ្រើសរើសបានអតិបរិមា ៣)",
  "groundMaxOne": "កម្ពស់ដីដើម (អាចជ្រើសរើស ១)",
  "designMaxOne": "កម្ពស់ការរចនា (អាចជ្រើសរើស ១)",
  "noAvailableLayers": "គ្មានស្រទាប់អាចប្រើប្រាស់",
  "earthworkSummaryTable": "តារាងសង្ខេបដីសំណង់ទាំងអស់",
  "downloadOverallSummaryTable": "ទាញយកតារាងសង្ខេបទាំងអស់",
  "summaryTableTooltip": "ពិនិត្យតារាងសង្ខេបទាំងអស់នៅពេលបង្កើតឯកសារផ្នែកឆ្លង។"
} as const;

export default graph;
